import React, { useEffect, useState } from 'react'

import { SingleSelect } from '../SelectDropdown'

import axiosInstance from '../../services/config/AxiosIntance'

const SingleVacancyTypeSelect = ({
  vacancyType,
  onSelectVacancyType,
  validationError,
}) => {
  const [vacancyTypeList, setVacancyTypeList] = useState([])

  useEffect(() => {
    axiosInstance
      .get('/jobs/vacancy-types')
      .then((res) => {
        const formattedList = res?.data?.result?.map((e) => ({
          value: e.id,
          label: e.name,
        }))
        setVacancyTypeList(formattedList)
      })
      .catch((err) => {
        throw new Error('Error fetching vacancy types: ' + JSON.stringify(err))
      })
  }, [])

  return (
    <SingleSelect
      title="Vacancy Type"
      selected={vacancyType}
      options={vacancyTypeList}
      placeholder="Please select a vacancy type..."
      onChange={onSelectVacancyType}
      wrapperClass={validationError && 'error'}
      subText={validationError}
    />
  )
}

export default SingleVacancyTypeSelect
